<template>
  <div
    :style="{ backgroundColor: drawerOptions.bgColor }"
    class="c-drawerColored fill-height"
  >
    <router-link to="/">
      <v-img
        class="c-drawerColored__logo"
        :src="require('@/assets/logo_adveroo.svg')"
        contain
        height="18"
        position="left center"
      />
    </router-link>

    <div>
      <h2 class="text-h3 navy--text text--darken-1 font-weight-bold pb-8">
        {{ drawerOptions.title }}
      </h2>
      <p class="body-2 navy--text text--darken-1">{{ drawerOptions.text }}</p>
    </div>

    <div class="c-drawerColored__ico">
      <v-img :src="getIcoUrl(drawerOptions.ico)" contain height="174" />
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    drawerOptions() {
      return this.$route.meta.drawerOptions
    },
  },
  methods: {
    getIcoUrl(name) {
      return require(`@/assets/${name}`)
    },
  },
}
</script>

<style scoped>
.c-drawerColored {
  padding: 43px 45px 39px 40px;
  position: relative;
}

.c-drawerColored__logo {
  margin-bottom: 122px;
}

.c-drawerColored__ico {
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>
